import { Locale } from '~/contentful/model/locale';

/**
 * Formats the given date with the given options. The options are applied on top
 * of the following default values:
 * ```ts
 * {
 *   date: 'numeric',
 *   month: 'long',
 *   year: 'numeric',
 *   timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
 * }
 * ```
 *
 * @param date The date to be formatted
 * @param options The options to apply when formatting the date.
 */
export function formatDate(
  date: number | string | Date,
  options?: { formatOptions?: Intl.DateTimeFormatOptions; locale?: Locale },
) {
  const formatOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...(options && options.formatOptions),
  };
  const { locale = Locale.EN_US } = options || {};

  const dateTimeFormat = new Intl.DateTimeFormat(locale, formatOptions);
  return dateTimeFormat.format(new Date(date));
}
